import {createAction, props} from "@ngrx/store";
import {WindowModel} from '@happy-windows/api-interfaces';

export const InitContentWindow = createAction('[WindowContent] InitContentWindow');
export const ToggledContentWindow = createAction('[WindowContent] ToggledContentWindow', props<{ window: WindowModel }>());
